// extracted by mini-css-extract-plugin
export default {"add-admin":"AdminStep_add-admin__nfeZ7","note":"AdminStep_note__A6wd0","input":"AdminStep_input__p-qM6","actions":"AdminStep_actions__UuRDb"};